import Vue from 'vue';
import Vuex from 'vuex';

import {HTTP} from '../http-common';
import EventBus from "../components/event-bus";
import {commonMixins} from '../mixins/commonMixins';

Vue.use(Vuex);

export const store = new Vuex.Store({
    mixins: commonMixins,
    state: {
    },
    mutations: {
    },
    actions: {
    },
    getters: {
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js